export default function Footer() {
  return (
    <footer id="community" className="bg-gradient-to-br from-pink-500 via-purple-500 to-pink-600 text-white py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Mawariと共に歩む仲間の場所
          </h2>
          <p className="text-xl text-white/90">
            一緒に未来を創りましょう
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div>
            <div className="flex items-center mb-6">
              <img
                src="https://static.readdy.ai/image/019c42ef209c92acff15d1e580b417d6/19f5ffb7ee66b02c49330cb25beab366.png"
                alt="Mawari FREAK"
                className="h-14 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-white/80 text-base leading-relaxed">
              世界一やさしいMawariポータルサイト
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">About</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors text-base cursor-pointer">
                  Mawari FREAKについて
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors text-base cursor-pointer">
                  利用ガイド
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors text-base cursor-pointer">
                  プライバシーポリシー
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors text-base cursor-pointer">
                  利用規約
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">Community</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors text-base cursor-pointer">
                  コミュニティ参加
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors text-base cursor-pointer">
                  イベント情報
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors text-base cursor-pointer">
                  サポートフォーラム
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors text-base cursor-pointer">
                  よくある質問
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors text-base cursor-pointer">
                  お問い合わせ
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors text-base cursor-pointer">
                  フィードバック
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors text-base cursor-pointer">
                  パートナーシップ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-white/70 text-base mb-4 md:mb-0">
              © 2025 Mawari FREAK. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-discord-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-telegram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer">
                <i className="ri-youtube-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}